import { IPreloadedState } from 'shared/types/redux';

export const selectSupplyDemand = (state: IPreloadedState) => state.marketTrends.supplyDemand;
